export default "assets/images/logo-footer-32d4e13d.png";